<template>
  <div class="collapse" :class="{ 'mb-1': !isOpen }">
    <div class="collapse-head" @click.self="isOpen = !isOpen">
      <div class="mr-6px" @click="isOpen = !isOpen">
        <v-icon v-if="isOpen">expand_less</v-icon>
        <v-icon v-else>expand_more</v-icon>
      </div>
      <div @click="isOpen = !isOpen" class="d-flex">
        <slot name="head">head</slot>
      </div>
      <slot name="actions"></slot>
    </div>
    <div class="collapse-body" v-if="isOpen">
      <slot name="body">body</slot>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isOpen: true,
  }),
};
</script>

<style></style>
